import {
    UserLocalOptionsClient,
} from 'src/common/UserLocalOptionsClient/UserLocalOptionsClient';
import { UserLocalOptionsClientInterface } from 'src/common/UserLocalOptionsClient/UserLocalOptionsClientInterface';

export async function createUserLocalOptionsClient(
    userOptionsStore: LocalForage,
): Promise<UserLocalOptionsClientInterface> {
    const client = new UserLocalOptionsClient(userOptionsStore);
    await client.initialize();
    return client;
}
